module.exports = __webpack_public_path__ + "media/efdab_1.1b.aa02e4b1.mp3";